import ApiServiceBase from '@/services/ApiServiceBase'
import jiff from 'jiff'

const getDefaultState = () => {
  return {
    all: []
  }
}

export const namespaced = true

export class User {
  constructor () {
    this.id = null
    this.firstName = ''
    this.lastName = ''
    this.userName = ''
    this.email = ''
    this.phoneNumber = ''
    this.isOptedIn = true
    this.isAdmin = false

    this.fullName = ''
  }
}

export const state = getDefaultState()

export const mutations = {
  SET_USERS_LIST (state, users) {
    state.all = users
  },
  ADD_LIST_USER (state, newUser) {
    state.all.push(newUser)
  },
  ADD_OR_UPDATE_LIST_USER (state, addOrUpdUser) {
    const index = state.all.findIndex(u => u.id === addOrUpdUser.id)
    if (index === -1) {
      state.all.push(addOrUpdUser)
    } else {
      state.all.splice(index, 1, addOrUpdUser)
    }
  },
  DELETE_LIST_USER (state, userId) {
    const index = state.all.findIndex(u => u.id === userId)
    if (index !== -1) {
      state.all.splice(index, 1)
    }
  },
  DELETE_LIST_USERS (state, userIds) {
    userIds.forEach(userId => {
      const index = state.all.findIndex(u => u.id === userId)
      if (index !== -1) {
        state.all.splice(index, 1)
      }
    })
  },
  RESET_STATE (state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState())
  }
}

export const actions = {
  loadUsers ({ commit }) {
    return ApiServiceBase.find({
      resource: 'auth/user',
      query: null
    }).then(response => {
      commit('SET_USERS_LIST', response.data)
    })
  },
  getUser ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      if (!userId) {
        resolve(new User())
      } else {
        ApiServiceBase.get({
          resource: 'auth/user',
          id: userId,
          query: null
        })
          .then(response => {
            commit('ADD_OR_UPDATE_LIST_USER', response.data)
            resolve(response.data)
          })
          .catch(err => {
            reject(err)
          })
      }
    })
  },
  getEditableUser ({ dispatch }, userId) {
    return dispatch('getUser', userId).then(user => {
      if (!userId) {
        return user
      } else {
        return Object.assign(new User(), user)
      }
    })
  },
  createUser ({ commit }, newUser) {
    return ApiServiceBase.create({
      resource: 'auth/user',
      data: newUser,
      query: null
    }).then(response => {
      commit('ADD_LIST_USER', response.data)
      return response
    })
  },
  updateUser ({ commit, state }, updUser) {
    const existing = state.all.find(u => u.id === updUser.id)
    const patch = jiff.diff(existing, updUser, {
      hash: JSON.stringify,
      makeContext: null
    })

    return ApiServiceBase.update({
      resource: 'auth/user',
      id: updUser.id,
      data: patch,
      query: null
    }).then(response => {
      commit('ADD_OR_UPDATE_LIST_USER', response.data)
      return response
    })
  },
  deleteUser ({ commit }, userId) {
    return ApiServiceBase.delete({
      resource: 'auth/user',
      id: userId,
      query: null
    }).then(() => {
      commit('DELETE_LIST_USER', userId)
    })
  },
  batchDeleteUsers ({ commit }, userIds) {
    return ApiServiceBase.custom((http) => {
      return http.post('auth/user/batchdelete', { userIds })
    }).then((result) => {
      commit('DELETE_LIST_USERS', userIds)
      return result.data
    })
    .catch((result) => {
      return result
    });
  }
}

export const getters = {}
